import style from './style.module.scss';
import { BackButton, Content, TgWidget } from '@/components';
import Image from 'next/image';
import Link from 'next/link';
import { DateView } from '@/ui';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import notImage from '../../../public/not-image.png';
import { NewsPoster } from '..';

export const NewsDetail = ({ data, type }: any) => {
  const poster = data?.detailPicture?.url !== undefined
  ? process.env.NEXT_PUBLIC_APP_UPLOAD_URL + data?.detailPicture?.url
  : notImage
  return (
    <div>
      <div className={style.back}>
        <BackButton link={`/${type}`} />
      </div>
      <Content>
        <div className={style.news_wrapper}>
          <div className={style.news}>
            <div className={style.poster}>
             
              <NewsPoster poster={poster} />

              <div className={style.date}>
                <DateView dateCreate={data.date ?? data.createdAt} />
              </div>
            </div>
            <div className={style.content}>
              <h1 className={style.title}>{data?.title}</h1>
              <Markdown rehypePlugins={[rehypeRaw]} className={style.description}>
                {data?.description}
              </Markdown>
            </div>
            {data?.source && (
              <div className={style.link}>
                <p>
                  <Link target="_black" href={data?.source || ''}>
                    Источник
                  </Link>
                </p>
              </div>
            )}
          </div>

          {/* <div className={style.tg_widget}>
            <TgWidget />
          </div> */}
        </div>
      </Content>
    </div>
  );
};
